import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UploadFile } from '@mui/icons-material';

import { selectUserRoles } from '@store/auth';

import ApplicationTemplate from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';

import { IMAGE_UPLOAD_ROUTE } from './payment-options.breadcrumbs';

import { ROLES } from '../../app/App.constants';

import { getFirstRoute } from '../../utils/utils';
import FileUploadUI from './pages/uploadimages/FileUpload';

const tabs = [
  {
    title: 'Upload Images',
    icon: <UploadFile />,
    path: IMAGE_UPLOAD_ROUTE,
    roles: [ROLES.ROLE_ADMIN, ROLES.ROLE_UPLOADS],
  },
  { divider: true },
];

function Options() {
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="/uploadimages"
          exact
          element={<FileUploadUI />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default Options;
